<template>
  <div 
    >
    <div v-if="isLoading" class="absolute inset-0 bg-white/30 dark:bg-black/30 backdrop-blur-md flex items-center justify-center z-50 rounded-md">
      <Vue3Lottie :animationData="loading1" :height="40" :width="97" />
    </div>
    <div class="flex justify-end gap-2 mt-1 mr-1">
      <div v-on:click="openModal=true" class="flex items-center justify-center cursor-pointer hover:scale-110 transition-transform duration-300" >
        <svg class="p-auto w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 15v2a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-2m-8 1V4m0 12-4-4m4 4 4-4"/>
        </svg>
      </div>
        <input
        type="date"
        required
        class="p-2 dark:[color-scheme:dark] border dark:border-gray-600 dark:bg-gray-700 dark:text-white text-sm rounded outline-none"
        v-model="datePicker"
      />
      <button v-on:click="getDataChartHandler">
        <svg class="h-4 w-4 fill-current dark:text-white" xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 56.966 56.966">
          <path
            d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z" />
        </svg>
      </button>
      <div class="flex items-center justify-center gap-2">
        <button type="button" v-on:click="previousDate" class="relative flex items-center justify-center font-medium min-w-[2rem] px-1.5 h-8 -my-3 rounded-md outline-none hover:bg-gray-500/5 focus:bg-yellow-500/10 focus:ring-2 focus:ring-yellow-500 dark:hover:bg-gray-400/5 transition text-yellow-600">
          <svg class="w-7 h-7 rtl:scale-x-[-1]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd"></path>
          </svg>
        </button>
        <button type="button"  :disabled="isToday"  v-on:click="nextDate" class="relative flex items-center justify-center font-medium min-w-[2rem] px-1.5 h-8 -my-3 rounded-md outline-none hover:bg-gray-500/5 focus:bg-yellow-500/10 focus:ring-2 focus:ring-yellow-500 dark:hover:bg-gray-400/5 transition text-yellow-600">
          <svg class="w-7 h-7 rtl:scale-x-[-1]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path>
          </svg>
        </button>
      </div>
    </div>

    <apexchart height="350" type="area" :options="optionsArea" :series="seriesArea"></apexchart>
    <br />
    <hr />
  </div>
  <Modal
  title="Download Setup"
  btnTextSubmit="Download"
  btnText="Add Group"
  btnType="submit"
  :btnShow="false"
  :isOpenEx="openModal"
  @updateOpen="openModal=false"
  @submitForm="downloadExcelHandler"
>
  <template v-slot:body>
    <div class="space-y-5 pb-5">
      <div class="space-y-3">
        <div class="flex gap-2 justify-between">
          <div class="flex-1 w-50">
            <p>Start Date</p>
            <input
              type="date"
              required
              placeholder=""
              class="p-2 dark:[color-scheme:dark] border dark:border-gray-600 dark:bg-gray-700 w-full rounded outline-none"
              v-model="downloadSetup.startDate"
            />
          </div>
          <div v-if="isCheckRange" class="flex-1 w-50" >
            <p>End Date</p>
            <input
              type="date"
              placeholder=""
              required
              class="p-2 dark:[color-scheme:dark] border dark:border-gray-600 dark:bg-gray-700 w-full rounded outline-none"
              v-model="downloadSetup.endDate"
            />
          </div>
        </div>
        <div class="flex justify-between items-center mb-4">
          <div class="items-center flex">
            <input id="default-checkbox" v-model="isCheckRange" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
            <label for="default-checkbox" class="ms-2 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">Range Date</label>
          </div>
          <div v-if="page" class="items-center flex">
            <input id="default-checkbox" v-model="isCheckRange2" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
            <label for="default-checkbox" class="ms-2 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">Include Temperature</label>
          </div>
          </div>
      </div>
    </div>
  </template>
</Modal>
</template>
<script>
  import { useCounterStore } from "@/store/counter";
  import { mapActions, mapState } from "pinia";
  import loading1 from "../assets/loading9.json";
  import { Vue3Lottie } from 'vue3-lottie';
  import Modal from '@/components/modal.vue';
  import { Icon } from "@iconify/vue";

  export default {
    name: "Chart Component",
    props: {
      plantId: {
        type: String,
        required: true,
      },
      page: {
        type: Boolean,
        default: true
      }
    },
    components: {
     Vue3Lottie, Modal, Icon
    },
    data() {
      return {
        chart: {
          fontFamily: "lexend, sans-serif",
        },
        optionsArea: {
          chart: {
            type: 'area',
            height: 300,
            zoom: {
              enabled: false
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight'
          },

          title: {
            text: 'Humidity Statictis',
            align: 'left'
          },
          labels: [],
          xaxis: {
            categories: this.page ? [
              '00:00', '01:00', '02:00', '03:00',
              '04:00', '05:00', '06:00', '07:00',
              '08:00', '09:00', '10:00', '11:00',
              '12:00', '13:00', '14:00', '15:00',
              '16:00', '17:00', '18:00', '19:00',
              '20:00', '21:00', '22:00', '23:00'
            ] : ['00:00', '00:30', '01:00', '01:30','02:00', '02:30','03:00', '03:30', '04:00', '04:30', '05:00', '05:30',
              '06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30',
              '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30',
              '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00', '22:30','23:00', '23:30'
            ],
            title: {
              text: 'Hours'
            },
          },
          yaxis: {
            opposite: true,
            min: 0,
            max: 100
          },
          legend: {
            horizontalAlign: 'left'
          }
        },
        datePicker: '',
        loading1,
        isLoading: false,
        openModal: false,
        tempDate: '',
        isCheckRange: false,
        isCheckRange2: this.page,
        downloadSetup: {
          startDate: '',
          endDate: '',
        },

      };
    },
    methods: {
      ...mapActions(useCounterStore,['getDataChart', 'downloadExcel']),
      async downloadExcelHandler() {
        if(this.isCheckRange === false) {
          this.downloadSetup.endDate = null
        }
        const inc = this.page === false ? 3 : ( this.isCheckRange2 ? 1 : 2)
        await this.downloadExcel(this.downloadSetup.startDate, this.downloadSetup.endDate, [this.plantId], inc)
      },
      previousDate() {
        this.tempDate = this.datePicker
        let date = new Date(this.datePicker);
        date.setDate(date.getDate() - 1);
        this.datePicker = date.toISOString().split('T')[0];
        this.getDataChartHandler()
      },
      async getDataChartHandler(){
        this.isLoading = true
        let check
        if(this.page){
          check = await this.getDataChart(this.plantId ,this.datePicker, false)
        }else{
          check = await this.getDataChart(this.plantId + ",12,13",this.datePicker, true)
        }
        if(check){
          this.isLoading = false
        }else{
          this.datePicker = this.tempDate
          this.isLoading = false
        }
      },
      nextDate() {
        this.tempDate = this.datePicker
        let date = new Date(this.datePicker);
        date.setDate(date.getDate() + 1); 
        this.datePicker = date.toISOString().split('T')[0];
        this.getDataChartHandler()
      }
    },
    created(){
      if(this.page){
      this.getDataChartHandler()

      }
      const now = new Date();
      const jakartaDate = new Date(now.toLocaleString("en-US", { timeZone: "Asia/Jakarta" }));
      const yyyy = jakartaDate.getFullYear();
      const mm = String(jakartaDate.getMonth() + 1).padStart(2, '0');
      const dd = String(jakartaDate.getDate()).padStart(2, '0');
      this.datePicker = `${yyyy}-${mm}-${dd}`;

    },
    computed: {
      ...mapState(useCounterStore, [ 'seriesArea', ]),
      isToday() {
        const selected = new Date(this.datePicker);
        const today = new Date();
        return (
          selected.getFullYear() === today.getFullYear() &&
          selected.getMonth() === today.getMonth() &&
          selected.getDate() === today.getDate()
        );
      }
    },
    watch: {
      plantId(newVal){
        if(newVal){
          console.log(this.plantId)
          this.getDataChartHandler()
        }
      }
    }
  };
</script>